export { default as useEdUpdateQuery } from './useEdUpdateQuery';
